// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3807":"db43f59aee218966","5149":"401f49fea547e2d4"}[chunkId] + ".css";
};